import List from "./List";
import Form from "./Form";
import New from "./New";

export default { List, Form, New };
